export enum LogicalOperatorEnum {
    And = 0,
    Or = 1,
}
